import { useApiRequestAdminSearchOrdersByCampaignWithOrderId } from '@hooks-api/fortune-fastpass/use-api-admin-search-orders-by-campaign'
import { useParams } from 'react-router-dom-v5'
import { useCampaign } from './use-campaign'

export function useAdminOrders() {
  const { campaignCodeFromUrl } = useCampaign()
  const { orderId } = useParams<{ orderId?: string }>()
  const adminOrders = useApiRequestAdminSearchOrdersByCampaignWithOrderId({ id: orderId ?? null, code: campaignCodeFromUrl })
  return adminOrders
}
